import { render, staticRenderFns } from "./index.vue?vue&type=template&id=498142aa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=498142aa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498142aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\mam\\home\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('498142aa')) {
      api.createRecord('498142aa', component.options)
    } else {
      api.reload('498142aa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=498142aa&scoped=true", function () {
      api.rerender('498142aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/index.vue"
export default component.exports